module.exports = __webpack_public_path__ + "img/wenhao.76a5c71f.png";